<div class="graph mat-elevation-z2">
  <div id="chart" class="plotly-graph"></div>
</div>
